if (!customElements.get('personalize-product')) {
  class PersonalizeProduct extends HTMLElement {
    constructor() {
      super();
  
      this.form = this.querySelector('form');
      this.personalizeOptions = document.querySelector('[data-personalize-options]');
      this.submitFormButton = this.querySelector('button[type="submit"]');
      this.optionsToSend = this.querySelector('[data-personalized-output]');
      this.openModalButton = document.querySelector('[aria-controls="personalize-product-modal"]')
      this.selectedOptionHtml = document.querySelector('[data-selected-option]');
      this.selectedVariant = JSON.parse(this.getAttribute('data-selected-variants'));
      this.productOptions = JSON.parse(this.getAttribute('data-product-options'));
      this.selectedVariantHTML = this.querySelector('[data-selected-variant-html]');
  
      if (!this.form || !this.personalizeOptions || !this.submitFormButton || !this.optionsToSend) {
        return;
      }
    }
  
    connectedCallback() {
      this.submitFormButton.addEventListener('click', (event) => {
        event.preventDefault();
  
        if (!this.form.reportValidity()) {
          return;
        }
  
        this.optionsToSend.innerHTML = '';
  
        this.personalizeOptions.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = radio.name;
          input.value = radio.value;
          this.optionsToSend.appendChild(input);
        });
  
  
        const currentUrl = new URL(window.location);
        sessionStorage.setItem('personalize_last_url', currentUrl.toString());

        const labeledOptions = this.selectedVariant.options.map((value, index) => {
          return {
            label: this.productOptions[index],
            value: value
          };
        });

        labeledOptions.forEach((option) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `contact[${option.label}]`;
          input.value = option.value;
          this.optionsToSend.appendChild(input);
        });
  
        this.form.submit();
      });
  
      this.openModalButton.addEventListener('click', () => {
        const selectedOption = this.personalizeOptions.querySelector('input[type="radio"]:checked');
  
        if (!selectedOption) {
          return;
        }
  
        const nameAttr = selectedOption.getAttribute('name'); 
        const match = nameAttr.match(/\[(.*?)\]/);
        const optionName = match ? match[1] : '';
  
        this.selectedOptionHtml.innerHTML = '';
        this.selectedOptionHtml.innerHTML = `${window.themeVariables.strings.selected}: ${optionName}: ${selectedOption.value}`;

        const labeledOptions = this.selectedVariant.options.map((value, index) => {
          return {
            label: this.productOptions[index],
            value: value
          };
        });

        this.selectedVariantHTML.innerHTML = '';

        labeledOptions.forEach((option) => {
          const p = document.createElement('p');
          p.innerHTML = `${option.label}: ${option.value}`;
          this.selectedOptionHtml.appendChild(p);
        });
      });

      document.addEventListener('variant:change', (event) => {
        this.selectedVariant = event.detail.variant;
      });
    }
  }

  customElements.define('personalize-product', PersonalizeProduct);
}